import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { LockEmspUserByIdModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/lock-emsp-user.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useLockEmspBoEmspUserContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserLockCreateFormStep1Controller } from '../emsp-bo-emsp-user-lock-create-form-step-1/emsp-bo-emsp-user-lock-create-form-step-1.controller';

// /////////////////////////////////////////////////////////////////////////////

interface EmspBoEmspUserLockCreateFormControllerProps {
  onError: SubmitErrorHandler<LockEmspUserByIdModel>;
  onSubmit: SubmitHandlerWithDirtyFields<LockEmspUserByIdModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoEmspUserLockCreateFormController = (
  props: EmspBoEmspUserLockCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useLockEmspBoEmspUserContext();

  return (
    <MultiStepFormProvider<LockEmspUserByIdModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['userId', 'duration'],
          component: <EmspBoEmspUserLockCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
